import { PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import api from "PFCore/api";

export type FetchInvitesPayload = {
  targetType: string;
  targetId: number;
  page?: number;
  perPage?: number;
};

export type FetchInvitesResponse = {
  entries: any[];
  meta: { total: number };
};

export const fetchInvites = ({
  targetType,
  targetId,
  page = 1,
  perPage = PER_PAGE_UNPAGINATED
}: FetchInvitesPayload) =>
  api<FetchInvitesResponse>({
    url: "invites",
    params: {
      targetType,
      targetId,
      page,
      perPage
    }
  });
